import { THEME } from 'components/theme'
// TODO(v0): Remove interfaces to separate files
export type ITranslate = (x: string, y?: { [key: string]: any }) => string

export enum API_RESPONSE_TYPE {
  SUCCESS,
  FAILURE
}
export interface IApiResponse<T = any> {
  data: T
  type: API_RESPONSE_TYPE
}

export interface IUserAuthData {
  access_token: string
  refresh_token: string
  expires_in: number
  new_user: boolean
  app_lock: boolean
}

export interface ILanguageEntity {
  id: number
  language: string
  label: string
  key: string
  color?: string
  bgColor?: string
}

export const LANGUAGES: ILanguageEntity[] = [
  {
    id: 1,
    language: 'English',
    label: 'English',
    key: 'en',
    color: '#b0121a',
    bgColor: '#ffe6e6'
  },
  {
    id: 2,
    language: 'Hindi',
    label: 'हिंदी (Hindi)',
    key: 'hi',
    color: '#005fa3',
    bgColor: '#e6f4ff'
  },
  {
    id: 3,
    language: 'Hinglish',
    label: 'Hinglish',
    key: 'afh'
  },
  {
    id: 4,
    language: 'Punjabi',
    label: 'ਪੰਜਾਬੀ (Punjabi)',
    key: 'pa'
  },
  {
    id: 5,
    language: 'Marathi',
    label: 'मराठी (Marathi)',
    key: 'mr',
    color: '#3945b3',
    bgColor: '#e9f0ff'
  },
  {
    id: 6,
    language: 'Gujarati',
    label: 'ગુજરાતી (Gujarati)',
    key: 'gu',
    color: '#007a29',
    bgColor: '#e5f6eb'
  },
  {
    id: 7,
    language: 'Tamil',
    label: 'தமிழ் (Tamil)',
    key: 'ta',
    color: '#b36500',
    bgColor: '#fdf8dc'
  },
  {
    id: 8,
    language: 'Telugu',
    label: 'తెలుగు (Telugu)',
    key: 'te',
    color: '#632bb3',
    bgColor: '#f0e6ff'
  },
  {
    id: 9,
    language: 'Kannada',
    label: 'ಕನ್ನಡ (Kannada)',
    key: 'kn',
    color: THEME.brandBlackAlt,
    bgColor: '#f4f4f4'
  },
  {
    id: 10,
    language: 'Malayalam',
    label: 'മലയാളം (Malayalam)',
    key: 'ml',
    color: '#9d14b3',
    bgColor: '#fce6ff'
  },
  {
    id: 11,
    language: 'Bengali',
    label: 'বাংলা (Bengali)',
    key: 'bn',
    color: '#70493e',
    bgColor: '#f5e2dc'
  }
]

export enum ENTITY_TYPE {
  CUSTOMER = 'customer',
  SUPPLIER = 'supplier'
}
export interface IFilterUnit {
  id: number
  label: string
  selected: boolean
}
export interface IFilterEntity {
  id: number
  label: string
  name: string
  entries: IFilterUnit[]
}

export enum FILTER_TYPES {
  SORT_FILTER = 0,
  SELECT_FILTER = 1,
  SEARCH_BY = 2
}
export enum SORT_FILTERS {
  NAME = 0,
  AMOUNT = 1,
  DUE_DATE = 2,
  DEFAULT = 3,
  LAST_PAYMENT = 4
}

export enum SEARCH_FILTER {
  CUSTOMERS = 0,
  INVOICE = 1
}

export enum SELECT_FILTER {
  DUE_TODAY = 0,
  DUE_PENDING = 1,
  DUE_UPCOMING = 2
}

// Sort options shown in the ledger sort sheet — mirrors the LEGACY Android app (the
// one that ships), not the KMP variant. Customer = all options in enum order; supplier
// drops both Last Payment AND Latest. Both tabs default to "Default".
// Labels are the exact Android string values (used verbatim as i18n keys in FilterDialog):
// DEFAULT→"Default" (R.string.latest), LAST_ACTIVITY→"Latest Activity", AMOUNT_DUE→"Due Amount".
const CUSTOMER_SORT_ENTRIES = [
  { id: SORT_FILTERS.DEFAULT, label: 'Default' },
  { id: SORT_FILTERS.LAST_PAYMENT, label: 'Last Payment' },
  { id: SORT_FILTERS.DUE_DATE, label: 'Latest Activity' },
  { id: SORT_FILTERS.AMOUNT, label: 'Due Amount' },
  { id: SORT_FILTERS.NAME, label: 'Name' }
]
// Supplier: no Last Payment, no Latest — just Default, Amount Due, Name.
const SUPPLIER_SORT_ENTRIES = CUSTOMER_SORT_ENTRIES.filter(
  (entry) => entry.id !== SORT_FILTERS.LAST_PAYMENT && entry.id !== SORT_FILTERS.DUE_DATE
)

const makeSortFilter = (
  entries: { id: SORT_FILTERS; label: string }[],
  selectedId: SORT_FILTERS
): IFilterEntity[] => [
  {
    id: FILTER_TYPES.SORT_FILTER,
    label: 'Sort By',
    name: 'sortBy',
    entries: entries.map((entry) => ({ ...entry, selected: entry.id === selectedId }))
  }
]

// Both customer and supplier default to "Default" (legacy Android).
export const InitialFilterValues: IFilterEntity[] = makeSortFilter(
  CUSTOMER_SORT_ENTRIES,
  SORT_FILTERS.DEFAULT
)
export const SupplierInitialFilterValues: IFilterEntity[] = makeSortFilter(
  SUPPLIER_SORT_ENTRIES,
  SORT_FILTERS.DEFAULT
)

export const InitialSearchByValues: IFilterEntity[] = [
  {
    id: FILTER_TYPES.SEARCH_BY,
    label: 'Search By',
    name: 'searchBy',
    entries: [
      {
        id: SEARCH_FILTER.CUSTOMERS,
        label: 'Customers',
        selected: true
      },
      {
        id: SEARCH_FILTER.INVOICE,
        label: 'Invoice',
        selected: false
      }
    ]
  }
]

export enum APP_CONSTANT {
  APP_NAME = 'okcweb-merchant'
}

export const StatesCodeMapper: Record<string, string> = {
  '01': 'JAMMU AND KASHMIR',
  '02': 'HIMACHAL PRADESH',
  '03': 'PUNJAB',
  '04': 'CHANDIGARH',
  '05': 'UTTARAKHAND',
  '06': 'HARYANA',
  '07': 'DELHI',
  '08': 'RAJASTHAN',
  '09': 'UTTAR PRADESH',
  '10': 'BIHAR',
  '11': 'SIKKIM',
  '12': 'ARUNACHAL PRADESH',
  '13': 'NAGALAND',
  '14': 'MANIPUR',
  '15': 'MIZORAM',
  '16': 'TRIPURA',
  '17': 'MEGHALAYA',
  '18': 'ASSAM',
  '19': 'WEST BENGAL',
  '20': 'JHARKHAND',
  '21': 'ORISSA',
  '22': 'CHHATTISGARH',
  '23': 'MADHYA PRADESH',
  '24': 'GUJARAT',
  '26': 'DADAR AND NAGAR HAVELI & DAMAN AND DIU',
  '27': 'MAHARASHTRA',
  '29': 'KARNATAKA',
  '30': 'GOA',
  '31': 'LAKSHADWEEP',
  '32': 'KERALA',
  '33': 'TAMIL NADU',
  '34': 'PUDUCHERRY',
  '35': 'ANDAMAN AND NICOBAR',
  '36': 'TELANGANA',
  '37': 'ANDHRA PRADESH',
  '38': 'LADAKH',
  '97': 'OTHER TERRITORY',
  '99': 'OTHER COUNTRY'
}
